import * as ValidationPatterns from './custom-validation-patterns.const';
import {
  AT_LEAST_ONE_DIGIT_PATTERN,
  AT_LEAST_ONE_LOWERCASE_CHARACTER_PATTERN,
  AT_LEAST_ONE_SPECIAL_CHARACTER_PATTERN,
  AT_LEAST_ONE_UPPERCASE_CHARACTER_PATTERN
} from './custom-validation-patterns.const';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';

export default class CustomValidators {

  static consecutiveCharsValidator(control: FormControl): ValidationErrors {
    const value = control.value.toLowerCase();
    for (let i = 2; i < value.length; i++) {
      // we only check alphanumeric consecutive and ignore special symbols
      if (!isAlphaNumeric(value.charAt(i)) || !isAlphaNumeric(value.charAt(i - 1)) || !isAlphaNumeric(value.charAt(i - 2))) {
        continue;
      }

      if ((value.charCodeAt(i) - value.charCodeAt(i - 1) === 1 && value.charCodeAt(i - 1) - value.charCodeAt(i - 2) === 1) ||
        (value.charCodeAt(i) - value.charCodeAt(i - 1) === -1 && value.charCodeAt(i - 1) - value.charCodeAt(i - 2) === -1)) {
        return {consecutiveChars: {value: control.value}};
      }
    }
    return null;
  }

  static repeatingCharsValidator(control: FormControl): ValidationErrors {
    const value = control.value.toLowerCase();
    for (let i = 2; i < value.length; i++) {
      if (value.charAt(i) === value.charAt(i - 1) && value.charAt(i - 1) === value.charAt(i - 2)) {
        return {repeatingChars: {value: control.value}};
      }
    }
    return null;
  }

  static atLeastOneLowerCaseCharacterValidator(control: FormControl): ValidationErrors {
    return isValid(new RegExp(AT_LEAST_ONE_LOWERCASE_CHARACTER_PATTERN), control.value) ?
      null : {atLeastOneLowerCaseCharacter: {value: control.value}};
  }

  static atLeastOneUpperCaseCharacterValidator(control: FormControl): ValidationErrors {
    return isValid(new RegExp(AT_LEAST_ONE_UPPERCASE_CHARACTER_PATTERN), control.value) ?
      null : {atLeastOneUpperCaseCharacter: {value: control.value}};
  }

  static atLeastOneDigitValidator(control: FormControl): ValidationErrors {
    return isValid(new RegExp(AT_LEAST_ONE_DIGIT_PATTERN), control.value) ?
      null : {atLeastOneDigit: {value: control.value}};
  }

  static atLeastOneSpecialCharacterValidator(control: FormControl): ValidationErrors {
    return isValid(new RegExp(AT_LEAST_ONE_SPECIAL_CHARACTER_PATTERN), control.value) ?
      null : {atLeastOneSpecialCharacter: {value: control.value}};
  }

  static ssnLengthValidator(control: FormControl): ValidationErrors {
    return control.value.replace(/-/g, '').length === 9 ? null : {invalidSsnLength: {value: control.value}};
  }

  static dobNotFutureValidator(maxDate: NgbDate): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return !control.value || !maxDate.before(control.value) ? null : {futureDobValue : {value: control.value}};
    };
  }

  static dobAfterMinDate(minDate: NgbDate): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return !control.value || !minDate.after(control.value) ? null : {dobIsBeforeMinDate : {value: control.value}};
    };
  }

  static getConfirmPasswordValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const passwordInput = control.get('passwordInput');
    const confirmPasswordInput = control.get('confirmPasswordInput');

    return passwordInput && confirmPasswordInput && passwordInput.value === confirmPasswordInput.value ?
      null : { passwordAreNotEqual: true };
  }

  static getConfirmEmailValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const emailInput = control.get('emailInput');
    const confirmEmailInput = control.get('confirmEmailInput');

    return emailInput && confirmEmailInput && emailInput.value === confirmEmailInput.value ?
      null : { emailsAreNotEqual: true };
  }
}

function isValid(regex: RegExp, value: string): boolean {
  return regex.test(value);
}

function isAlphaNumeric(value: string): any {
  return value.match(ValidationPatterns.ALPHANUMERIC_SYMBOLS_PATTERN);
}
